import '../../styles/pages/video-project-detail.scss';

import Splide from '@splidejs/splide';
import generateTabs from '../components/generateTabs';

generateTabs('sidebar-last', { isLoadMore: false });

const allVideoSliders = document.querySelectorAll('.splide-video-slider');

allVideoSliders.forEach((itm) => {
  const splide = new Splide(itm, {
    type: 'loop',
    perPage: 4,
    perMove: 1,
    pagination: false,
    gap: 32,
    flickPower: 100,
    breakpoints: {
      768: {
        perPage: 2,
      },
      1024: {
        perPage: 3,
        gap: 24,
      },
    }
  });

  splide.mount();
})

document.querySelector('.sidebar-last .load-more').addEventListener('click', function (e) {
    let active_tab = e.target.closest('.sidebar-last').querySelector('.tabs__item_active').dataset.tab || 'all';
    let tab_content = e.target.closest('.sidebar-last').querySelector(`[data-tabdata=${active_tab}]`);
    load_posts('/load-posts/', tab_content, 'list', tab_content.dataset.page, active_tab);
  });
  